export const NavigateHome = "/home";
export const NavigateSignin = "/signin";
export const NavigateSignup = "/signup";
export const NavigateNotFound = "page-not-found";
export const NavigateForbidden = "forbidden";
export const NavigateImageComparison = "admin-camera-comparison";